import { HAJJ_STATIONS } from "@/data/hajjTimeline";
import { MANASIK_TOPICS } from "@/data/manasikRef";
import api from "@/lib/api";

// Built-in (generated) manasik content merged with admin-managed docs from /api/dynamic/*:
// a doc whose key matches a built-in id overrides it, `hidden` removes it, other keys are appended.
// The last server copy is cached in localStorage so the merge also works offline.
const KEY = "manasik_content_v1";
export const DAY_ORDER = ["8", "9", "10", "tasyrik", "wada"];
const listeners = new Set();
let version = 0;

const read = () => {
  try { const v = JSON.parse(localStorage.getItem(KEY)); return v && Array.isArray(v.stations) && Array.isArray(v.topics) ? v : { stations: [], topics: [] }; }
  catch { return { stations: [], topics: [] }; }
};
let cache = read();
let merged = null;

const nz = (m) => (m && (m.id || m.en) ? m : undefined);
const stationFromDoc = (d) => ({
  id: d.key, day: d.day, status: d.status || "sunnah", loc: d.loc || undefined,
  arabic: d.arabic || undefined, translit: d.translit || undefined,
  title: d.title || { id: d.key }, body: d.body || [], dua: nz(d.dua), evidence: nz(d.evidence),
});
const topicFromDoc = (d) => ({
  id: d.key, icon: d.icon || "BookOpen", title: d.title || { id: d.key }, intro: d.intro || { id: "" },
  sections: d.sections || [], evidence: nz(d.evidence),
});

export const builtinOrder = (i) => (i + 1) * 10;
export const TOPIC_ICON_CHOICES = ["Layers", "Ban", "MapPin", "Scale", "Users", "ListChecks", "Footprints", "AlertTriangle", "Flower2", "BookOpen", "Heart", "Star", "Sparkles", "Compass", "Landmark", "Moon", "Sun", "Tent", "HandHeart", "Droplets", "Shield", "Baby", "Accessibility", "Stethoscope", "Wallet", "Plane"];

function mergeList(builtins, docs, fromDoc) {
  const byKey = new Map((docs || []).map((d) => [d.key, d]));
  const out = [];
  builtins.forEach((b, i) => {
    const d = byKey.get(b.id);
    byKey.delete(b.id);
    if (d?.hidden) return;
    out.push(d && !d.stub ? { ...fromDoc(d), order: d.order ?? builtinOrder(i), builtin: true, overridden: true } : { ...b, order: builtinOrder(i), builtin: true });
  });
  for (const d of byKey.values()) if (!d.hidden && !d.stub) out.push({ ...fromDoc(d), order: d.order ?? 9999, custom: true });
  return out;
}

const byDayThenOrder = (a, b) => DAY_ORDER.indexOf(a.day) - DAY_ORDER.indexOf(b.day) || a.order - b.order;

function compute() {
  return {
    stations: mergeList(HAJJ_STATIONS, cache.stations, stationFromDoc).sort(byDayThenOrder),
    topics: mergeList(MANASIK_TOPICS, cache.topics, topicFromDoc).sort((a, b) => a.order - b.order),
  };
}

export const getStations = () => (merged || (merged = compute())).stations;
export const getTopics = () => (merged || (merged = compute())).topics;
export const contentVersion = () => version;

export function subscribeManasikContent(fn) { listeners.add(fn); return () => listeners.delete(fn); }

// Pull the admin-managed docs (signed-in only); notifies subscribers when something changed.
export async function refreshManasikContent() {
  const [a, b] = await Promise.all([api.get("/dynamic/hajj-timeline"), api.get("/dynamic/manasik-ref")]);
  const next = { stations: a.data.items || [], topics: b.data.items || [] };
  if (JSON.stringify(next) === JSON.stringify(cache)) return false;
  cache = next;
  localStorage.setItem(KEY, JSON.stringify(cache));
  merged = null;
  version += 1;
  listeners.forEach((fn) => fn(version));
  return true;
}
